import React from "react";
import Logo from "../../Logo";
import { useDebounce } from "../../../../hooks/useDebounce";

export default function PreloaderOverlay({ message, active, isAbsolute }) {
  const debouncedActive = useDebounce(active, 250);

  if (debouncedActive === false) return null;
  return (
    <div
      className={`preloader-overlay ${active ? "active" : "inactive"}`}
      style={isAbsolute ? { position: "absolute" } : { position: "fixed" }}
    >
      <div className="preloader-overlay-content">
        <Logo isAlternate={true} />
        {message && <span className="message">{message}</span>}
        <div className="graph-loading">
          <span className="graph-loading__bar"></span>
          <span className="graph-loading__bar"></span>
          <span className="graph-loading__bar"></span>
          <span className="graph-loading__bar"></span>
          <span className="graph-loading__bar"></span>
        </div>
      </div>
    </div>
  );
}
